import {
    Modal,
    ModalBody,
    ModalContent,
    ModalOverlay,
    ModalProps,
    Text
} from '@chakra-ui/react'
import { ReactNode } from 'react'

interface ModalContainerProps extends ModalProps {
    title: string
    footer?: ReactNode
}

export default function ModalContainer({
    children,
    title,
    footer,
    ...props
}: ModalContainerProps) {
    return (
        <Modal size="3xl" {...props}>
            <ModalOverlay />
            <ModalContent
                px={{
                    base: 0,
                    xl: 6
                }}
                pt={{
                    base: 2,
                    xl: 4
                }}
                pb={4}
            >
                <ModalBody>
                    <Text fontSize="2xl" fontWeight="bold" mb="3">
                        {title}
                    </Text>
                    {children}
                </ModalBody>
                {footer}
            </ModalContent>
        </Modal>
    )
}
